import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs';
import { useForm, Controller } from 'react-hook-form';
import {
  Dialog, DialogTitle, DialogContent, IconButton, useMediaQuery, useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CalOthour from 'utils/functions/CalOthour';
import CalOtRate from 'utils/functions/CalOtRate';
import OtRequestForm from '../../components/Forms/OtRequestForm';
import * as actions from '../../redux/actions';
import { showAlert, confirmAsync } from '../../utils/functions/globalDialog';

export default function AddOt({ open, onClose, onCreated }) {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const timestamp = useSelector((state) => state.timestamp);
  const project = useSelector((state) => state.project);
  const me = useSelector((state) => state.me);
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();
  const [requestForOther, setRequestForOther] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedProject, setSelectedProject] = useState();
  const [claimOT, setClaimOT] = useState(false);
  const [date, setDate] = useState(dayjs());
  const [rate, setRate] = useState(1.5);

  useEffect(() => {
    if (!open) return () => { };
    dispatch(actions.meGet({}));
    dispatch(
      actions.timestampAll({
        dateStart: dayjs(date).startOf('day').toISOString(),
        dateEnd: dayjs(date).endOf('day').toISOString(),
        project_id: selectedProject?._id,
      }),
    );

    return () => { };
  }, [open, date, selectedProject]);

  useEffect(() => {
    if (!open) return () => { };
    dispatch(actions.projectAll({ time_tracking_available: true, lite: true }));
    return () => { };
  }, [open]);

  // เคลียร์ฟอร์มทุกครั้งที่เปิด modal ใหม่ — กันข้อมูลค้างจากครั้งก่อน
  useEffect(() => {
    if (open) {
      setRequestForOther(false);
      setSelectedEmployees([]);
      setSelectedProject(undefined);
      setClaimOT(false);
      setDate(dayjs());
      setRate(1.5);
    }
  }, [open]);

  const fetchTimestamp = async () => {
    await dispatch(
      actions.timestampAll({
        dateStart: dayjs(date).startOf('day').toISOString(),
        dateEnd: dayjs(date).endOf('day').toISOString(),
      }),
    );
  };

  const onSubmit = async (data) => {
    const confirm = await confirmAsync('ต้องการบันทึกข้อมูลใช่หรือไม่ ?');
    if (confirm) {
      if (selectedEmployees.length === 0) {
        showAlert('กรุณาเลือกพนักงาน');
        return;
      }
      if (!selectedProject) {
        showAlert('กรุณาเลือก Project');
        return;
      }

      try {
        const h = await CalOthour(data.startTime, data.endTime);
        const dataSubmit = {
          ...data,
          resquester: me?.userData?.id,
          project: selectedProject?._id,
          project_data: selectedProject,
          requester_data: me?.userData,
          timestamp: selectedEmployees,
          status_claim: claimOT,
          rate: CalOtRate(data.date, data.description),
          total_hours: h.toFixed(1),
        };

        await dispatch(actions.otRequestOrderCreate(dataSubmit));
        showAlert('ส่งคำขอ OT เรียบร้อยแล้ว');
        onCreated?.();
        onClose?.();
      } catch (err) {
        const msg =
          err?.response?.data?.error?.message ||
          err?.response?.data?.message ||
          err?.message ||
          'เกิดข้อผิดพลาดในการส่งคำขอ OT';
        showAlert(msg, { status: err?.response?.status });
      }
    }
  };

  const renderForm = () => (
    <form onSubmit={handleSubmit(onSubmit)}>
      <OtRequestForm
        control={control}
        Controller={Controller}
        timestamp={timestamp}
        project={project}
        requestForOther={requestForOther}
        setRequestForOther={setRequestForOther}
        selectedEmployees={selectedEmployees}
        setSelectedEmployees={setSelectedEmployees}
        selectedProject={selectedProject}
        setSelectedProject={setSelectedProject}
        claimOT={claimOT}
        setClaimOT={setClaimOT}
        date={date}
        setDate={setDate}
        fetchTimestamp={fetchTimestamp}
        rate={rate}
        setRate={setRate}
      />
    </form>
  );
  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3 } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', p: 1 }}>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, px: { xs: 1.5, sm: 3 } }}>
        {renderForm()}
      </DialogContent>
    </Dialog>
  );
}
